"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stock = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let Stock = class Stock {
};
tslib_1.__decorate([
    (0, typeorm_1.ViewColumn)(),
    tslib_1.__metadata("design:type", Number)
], Stock.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ViewColumn)(),
    tslib_1.__metadata("design:type", Number)
], Stock.prototype, "facilityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ViewColumn)(),
    tslib_1.__metadata("design:type", Number)
], Stock.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ViewColumn)(),
    tslib_1.__metadata("design:type", Number)
], Stock.prototype, "productId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ViewColumn)(),
    tslib_1.__metadata("design:type", Number)
], Stock.prototype, "variantId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ViewColumn)(),
    tslib_1.__metadata("design:type", Number)
], Stock.prototype, "quantity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ViewColumn)(),
    tslib_1.__metadata("design:type", Number)
], Stock.prototype, "reserved", void 0);
Stock = tslib_1.__decorate([
    (0, typeorm_1.ViewEntity)({ expression: `
    select 
        "companyId", 
        "facilityId", 
        "locationId", 
        "productId", 
        "variantId", 
        sum("quantity") as "quantity",
        sum("reserved") as "reserved"
    from package_quantity
    group by "companyId", "facilityId", "locationId", "productId", "variantId"
` })
], Stock);
exports.Stock = Stock;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvY2suanMiLCJzb3VyY2VSb290IjoiLi9zcmMvIiwic291cmNlcyI6WyJwYWNrYWdlcy9tb2RlbHMvc3JjL3N0b2NrLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxxQ0FBaUQ7QUFjMUMsSUFBTSxLQUFLLEdBQVgsTUFBTSxLQUFLO0NBZWpCLENBQUE7QUFkRztJQUFDLElBQUEsb0JBQVUsR0FBRTs7d0NBQ0s7QUFDbEI7SUFBQyxJQUFBLG9CQUFVLEdBQUU7O3lDQUNNO0FBQ25CO0lBQUMsSUFBQSxvQkFBVSxHQUFFOzt5Q0FDTTtBQUNuQjtJQUFDLElBQUEsb0JBQVUsR0FBRTs7d0NBQ0s7QUFDbEI7SUFBQyxJQUFBLG9CQUFVLEdBQUU7O3dDQUNLO0FBQ2xCO0lBQUMsSUFBQSxvQkFBVSxHQUFFOzt1Q0FDSTtBQUNqQjtJQUFDLElBQUEsb0JBQVUsR0FBRTs7dUNBQ0k7QUFkUixLQUFLO0lBWmpCLElBQUEsb0JBQVUsRUFBQyxFQUFDLFVBQVUsRUFBRTs7Ozs7Ozs7Ozs7Q0FXeEIsRUFBQyxDQUFDO0dBQ1UsS0FBSyxDQWVqQjtBQWZZLHNCQUFLIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgVmlld0NvbHVtbiwgVmlld0VudGl0eSB9IGZyb20gXCJ0eXBlb3JtXCI7XG5cbkBWaWV3RW50aXR5KHtleHByZXNzaW9uOiBgXG4gICAgc2VsZWN0IFxuICAgICAgICBcImNvbXBhbnlJZFwiLCBcbiAgICAgICAgXCJmYWNpbGl0eUlkXCIsIFxuICAgICAgICBcImxvY2F0aW9uSWRcIiwgXG4gICAgICAgIFwicHJvZHVjdElkXCIsIFxuICAgICAgICBcInZhcmlhbnRJZFwiLCBcbiAgICAgICAgc3VtKFwicXVhbnRpdHlcIikgYXMgXCJxdWFudGl0eVwiLFxuICAgICAgICBzdW0oXCJyZXNlcnZlZFwiKSBhcyBcInJlc2VydmVkXCJcbiAgICBmcm9tIHBhY2thZ2VfcXVhbnRpdHlcbiAgICBncm91cCBieSBcImNvbXBhbnlJZFwiLCBcImZhY2lsaXR5SWRcIiwgXCJsb2NhdGlvbklkXCIsIFwicHJvZHVjdElkXCIsIFwidmFyaWFudElkXCJcbmB9KVxuZXhwb3J0IGNsYXNzIFN0b2NrIHtcbiAgICBAVmlld0NvbHVtbigpXG4gICAgY29tcGFueUlkOiBudW1iZXI7XG4gICAgQFZpZXdDb2x1bW4oKVxuICAgIGZhY2lsaXR5SWQ6IG51bWJlcjtcbiAgICBAVmlld0NvbHVtbigpXG4gICAgbG9jYXRpb25JZDogbnVtYmVyO1xuICAgIEBWaWV3Q29sdW1uKClcbiAgICBwcm9kdWN0SWQ6IG51bWJlcjtcbiAgICBAVmlld0NvbHVtbigpXG4gICAgdmFyaWFudElkOiBudW1iZXI7XG4gICAgQFZpZXdDb2x1bW4oKVxuICAgIHF1YW50aXR5OiBudW1iZXI7XG4gICAgQFZpZXdDb2x1bW4oKVxuICAgIHJlc2VydmVkOiBudW1iZXI7XG59XG4iXX0=